/* eslint-disable import/no-anonymous-default-export */
import isValueValid from './isValueValid'

export default (price, decimal= 2) => {
  if (!isValueValid(price)) return ''
  
  const convertPrice = Number(price).toFixed(decimal)
  const parts = convertPrice.toString().split('.')

  return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '')
}